import { jsx as _jsx } from "react/jsx-runtime";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { DisplayText } from "../../DisplayText";
export var HeaderField = function (props) {
    var uiSchema = props.uiSchema, _a = props.formContext, formContext = _a === void 0 ? {} : _a;
    // @ts-ignore TODO: Typescript upgrade
    var title = getFieldTitle(uiSchema, formContext);
    return (_jsx(DisplayText, { element: "h3", size: "small", children: title }));
};
